import classNames from 'classnames';
import { useRef, useState } from 'react';

import FormButton from '../buttons/FormButton';
import TextField from '../fields/TextField';
import FormControl from '../forms/FormControl';
import PromotionDescription from '../typography/PromotionDescription';
import PromotionTitle from '../typography/PromotionTitle';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../styles/popups/delete-account-confirm-modal.module.css';

type DeleteAccountConfirmModalProps = {
    className?: string | null;
    onClosed?: (() => void) | null;
    onConfirmed?: (() => void) | null;
};

function DeleteAccountConfirmModal({
    className = null,
    onClosed = null,
    onConfirmed = null,
}: DeleteAccountConfirmModalProps) {
    const [opened, setOpened] = useState(true);
    const onClickCancel = () => {
        setOpened(false);
    };
    const onRequestClose = () => {
        setOpened(false);
    };
    const inputRef = useRef<{ focus: () => void } | null>(null);
    const onOpened = () => {
        if (inputRef.current !== null) {
            inputRef.current.focus();
        }
    };
    const [confirmValue, setConfirmValue] = useState('');
    const [confirmError, setConfirmError] = useState<string | null>(null);
    const onClickConfirm = () => {
        if ((confirmValue || '').toLowerCase() !== 'oui') {
            setConfirmError('Veuillez entrer OUI pour confirmer');
            return;
        }
        if (onConfirmed !== null) {
            onConfirmed();
        }
    };
    return (
        <Modal
            id="delete_confirm"
            opened={opened}
            withBackdrop
            withTransition
            className={classNames([styles.container, className])}
            onClosed={onClosed}
            onOpened={onOpened}
            requestClose={onRequestClose}
        >
            <Dialog>
                <PromotionTitle className={styles.title}>Supprimer votre compte</PromotionTitle>
                <PromotionDescription>
                    Êtes-vous certain de vouloir supprimer votre compte ?{' '}
                    <strong>Cette action est irréversible.</strong>
                </PromotionDescription>
                <FormControl
                    label="Entrez OUI dans le champ ci-dessous pour confirmer"
                    errors={confirmError !== null ? [confirmError] : null}
                    className={styles.control}
                >
                    <TextField
                        value={confirmValue}
                        errors={confirmError !== null ? [confirmError] : null}
                        onChange={setConfirmValue}
                    />
                </FormControl>
                <div className={styles.actions}>
                    <FormButton compact className={styles.button} onClick={onClickConfirm}>
                        Supprimer le compte
                    </FormButton>
                    <FormButton
                        compact
                        transparent
                        className={styles.button}
                        onClick={onClickCancel}
                    >
                        Annuler
                    </FormButton>
                </div>
            </Dialog>
        </Modal>
    );
}

export default DeleteAccountConfirmModal;
